import React, { useEffect } from 'react';
import { Button, Form, Input, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import AddressInput from '../Inputs/AddressInput';
import './HubForm.scss';

const initForm = {
  name: '',
  tag: 'CITY_HUB',
  startAddress: undefined,
};
const HubForm = ({ handleSubmit, action, hub, handleCancel }) => {
  const [form] = Form.useForm();
  const { t } = useTranslation('hubs');
  const { t: tc } = useTranslation('common');

  const setParams = (values) => {
    const params = { ...values };
    params.startAddress = values.startAddress?.address;
    params.startAddressLat = values.startAddress?.latLng?.lat;
    params.startAddressLng = values.startAddress?.latLng?.lng;

    return params;
  };
  const onFinishForm = (values) => {
    handleSubmit && handleSubmit(setParams(values));
  };

  useEffect(() => {
    if (action === 'new') {
      form.setFieldsValue(initForm);
    } else if (hub) {
      form.setFieldsValue({
        ...hub,
        startAddress: {
          address: hub?.startAddress,
          latLng: {
            lat: hub?.startAddressLat,
            lng: hub?.startAddressLng,
          },
        },
      });
    }
  }, [action, hub]);

  return (
    <div className="HubForm">
      <div className="FormHeader"></div>
      <div className="FormContent">
        <Form
          form={form}
          scrollToFirstError
          layout="vertical"
          requiredMark={false}
          colon={false}
          onFinish={onFinishForm}
        >
          <Form.Item label={t('name')} name="name" rules={[{ required: true, message: tc('required') }]}>
            <Input placeholder={t('name')} />
          </Form.Item>
          <Form.Item label={t('tag')} name="tag" rules={[{ required: true, message: tc('required') }]}>
            <Select
              placeholder={t('selectTag')}
              options={Object.keys(tc('hubTags', { returnObjects: true })).map((key) => ({
                value: key,
                label: tc(`hubTags.${key}`),
              }))}
            />
          </Form.Item>
          <Form.Item
            label={t('startAddress')}
            name="startAddress"
            rules={[
              {
                validator: (_, value) => {
                  if (value?.address && value?.latLng?.lat && value?.latLng?.lng) {
                    return Promise.resolve();
                  }

                  if (!value?.address) {
                    return Promise.reject(new Error(tc('required')));
                  }

                  return Promise.reject(new Error(tc('invalid')));
                },
              },
            ]}
          >
            <AddressInput
              placeholder={t('startAddress')}
              onSelect={(value) => form.setFieldsValue({ startAddress: value })}
            />
          </Form.Item>
        </Form>
      </div>
      <div className="FormFooter">
        <Button key="cancel" onClick={handleCancel}>
          {tc('cancel')}
        </Button>
        <Button type="primary" block size="large" onClick={() => form.submit()}>
          {action === 'new' ? tc('create') : tc('update')}
        </Button>
      </div>
    </div>
  );
};

export default HubForm;
